export const cleanUpInputs = form => {
  form.keys().forEach(key => {
    if (typeof form[key] === 'string') {
      form[key] = ''
    } else if (Array.isArray(form[key])) {
      form[key] = []
    } else {
      form[key] = null
    }
  })
}
